import {
  Box,
  Button,
  Stack,
  Typography,
  Checkbox,
  FormControlLabel,
  useMediaQuery,
  DialogContent,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { getSoldBook } from "app/services/ledgerAccount";
import { toast } from "react-toastify";
import {
  selectActiveSession,
} from "app/modules/schools/selectors";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  IndianCurrency,
  formatGuardianString,
  FormatFullName,
} from "app/utils/helper";
import CustomLoader from "app/components/common/CustomLoader";
import ExportButtonGroup from "app/components/common/ExportButtonGroup";
import CommonTable1 from "app/components/Tables/CommonTable1";
import CommonFilterDialog from "app/components/common/Dialogs/CommonFilterDialog";
import SaleBookPaymentDetail from "app/components/common/Dialogs/ledger/books/SaleBookPaymentDetail";
import SaleBookDialog from "app/components/common/Dialogs/ledger/books/SaleBookDialog";
import FilterButton from "app/components/common/FilterButton";
import UniversalExportDialog from "app/components/common/Dialogs/UniversalExportDialog";
import ByClassFilter from "app/components/commonSeperateMultipleFilter/ByClassFilter";
import { Helmet } from "react-helmet";
import { useClassData } from "app/hooks/globallyApplicable/useClassData";

const SaleBook = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const selectedSession = useSelector(selectActiveSession);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [classListToMutate, setClassListToMutate] = useState([]);

  const [state, setState] = useState({
    tableData: [],
    dialogData: {},
    installmentData: {},
    add: {
      class: "",
      section: "",
      student: "",
      bookType: "",
      bookTitle: "",
      collectionDate: new Date(),
      entityArr: [],
      payment: {
        totalAmount: 0,
        discountRemark: "",
        taxableAmount: 0,
        balance: 0,
        balanceRemark: "",
      },
    },
    book: "",
    selectedClass: "",
    section: "",
    classData: [],
    checkExportOptionsPdf: false,
    filterData: {},
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [dialogs, setDialogs] = useState({
    add: false,
    tPaid: false,
    installment: false,
    payment: false,
    export: false,
  });

  const [checkboxes, setCheckboxes] = useState({
    one: false,
  });

  const columns = [
    {
      header: "Sr.No",
      Cell: ({
        cell: {
          row: { id },
        },
      }) => (
        <Typography>
          {parseInt(id) + 1 < 10 ? `0${parseInt(id) + 1}` : parseInt(id) + 1}
        </Typography>
      ),
      maxSize: isMobile ? 40 : 30,
    },
    {
      header: "Class-Stream-Sec",
      accessorKey: "stream",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return <Typography>{original?.stream ?? "--"}</Typography>;
      },
      maxSize: isMobile ? 60 : 40,
    },
    {
      header: "Student Name",
      accessorKey: "name",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <>
            <Stack direction="row" alignItems="center" gap={0.6}>
              {/* <TableProfilePic image={original?.profilePic} /> */}
              <Box>
                <Typography>{original?.name}</Typography>
                <Typography>
                  {formatGuardianString(
                    original?.gender,
                    original?.fathername || original?.mothername || ""
                  )}
                </Typography>
              </Box>
            </Stack>
          </>
        );
      },
      maxSize: isMobile ? 60 : 40,
    },
    {
      header: "Mobile Number",
      accessorKey: "mobileNumber",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return <Typography>{original?.mobileNumber ?? "--"}</Typography>;
      },
      maxSize: isMobile ? 60 : 40,
    },
    {
      header: "First Invoice Number",
      accessorKey: "number",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <Typography>
            <Link
              to={`/ledger-n-account/books/pay-slip/${String(
                original?.number
              ).replace(/\//g, " ")}`}
              target="_blank"
              rel="noreferrer onopener"
            >
              {original?.number}
            </Link>
          </Typography>
        );
      },
      maxSize: isMobile ? 60 : 40,
    },
    {
      header: "Total Amount",
      accessorKey: "amount",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <Typography>{IndianCurrency(Number(original?.amount))}</Typography>
        );
      },
      maxSize: isMobile ? 60 : 40,
    },
    {
      header: "Total Paid",
      accessorKey: "paid",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <Typography
            sx={{
              cursor: "pointer",
              fontWeight: "500",
              color: "blue",
              textDecoration: "underline",
              display: "inline",
            }}
            onClick={() => {
              setDialogs((prev) => ({ ...prev, tPaid: original?.number }));
            }}
          >
            {IndianCurrency(Number(original?.paid))}
          </Typography>
        );
      },
      maxSize: isMobile ? 60 : 40,
    },
    {
      header: "Discount",
      accessorKey: "discount",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <Typography>
            {original?.discount ? IndianCurrency(original?.discount) : "--"}
          </Typography>
        );
      },
      maxSize: isMobile ? 60 : 40,
    },
    {
      header: "Balance",
      accessorKey: "balance",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <Typography>{IndianCurrency(Number(original?.balance))}</Typography>
        );
      },
      maxSize: isMobile ? 60 : 40,
    },
  ];

  const { classList: getClassDropdownData, error: getClassDropdownError } =
    useClassData();
  useEffect(() => {
    if (getClassDropdownError) {
      toast.error(getClassDropdownError?.message);
    }
    if (getClassDropdownData) {
      setState((prev) => ({ ...prev, classData: getClassDropdownData }));
    }
  }, [getClassDropdownData, getClassDropdownError]);

  const {
    refetch: getSoldBookRefetch,
    isLoading: getSoldBookLoading,
    isFetching: getSoldBookFetching,
  } = useQuery({
    queryKey: ["getSoldBook", selectedSession],
    queryFn: () =>
      getSoldBook({
        session: selectedSession,
        ...(state.selectedClass && { classDocId: state.selectedClass }),
        ...(state.section && { section: state.section }),
        ...(state.collectionFrom && { collectionFrom: state.collectionFrom }),
        ...(state.collectionTo && { collectionTo: state.collectionTo }),
        ...(checkboxes.one &&
          classListToMutate.length > 0 && {
            classList: JSON.stringify(classListToMutate),
          }),
      }),
    onSuccess: (res) => {
      setState((prev) => ({ ...prev, tableData: res?.data?.list }));
      setModalOpen(false);
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message);
    },
  });

  const tableData = state?.tableData?.map((item) => ({
    stream:
      FormatFullName(item?.className, item?.stream, item?.section) || "--",
    name: item?.studentName || "--",
    number: item?.firstInvoiceNumber || "--",
    amount: item?.totalAmount || "--",
    paid: item?.paidAmount || "--",
    discount: item?.discount,
    balance: item?.balance || "--",
    invoiceDocId: item?.invoiceDocId,
    profilePic: item?.profilePic,
    fathername: item?.fathername,
    mobileNumber: item?.studentDetail?.mobileNumber,
    gender: item?.studentDetail?.gender,
  }));

  let exportExcelArray = state.tableData?.map((item) => {
    return {
      Class_Stream_Sec:
        FormatFullName(item?.className, item?.stream, item?.section) || "--",
      Student_Name: item.studentName || "",
      "F.Name": item?.fathername ?? "",
      "Mob. No.": item?.studentDetail?.mobileNumber ?? "",
      First_Invoice_Number: item.firstInvoiceNumber ?? "--",
      Total_Amount: IndianCurrency(item.totalAmount) || "",
      Total_Paid: IndianCurrency(item.paidAmount) || "",
      Discount: IndianCurrency(item.discount) || "",
      Balance: IndianCurrency(item.balance) || "",
    };
  });

  let headerExcel = [
    "Class_Stream_Sec",
    "Student_Name",
    "F.Name",
    "Mob. No.",
    "First_Invoice_Number",
    "Total_Amount",
    "Total_Paid",
    "Discount",
    "Balance",
  ];

  useEffect(() => {
    const filteredList = selectedClasses?.map(({ classDocId, section }) => ({
      classDocId,
      section,
    }));
    setClassListToMutate(filteredList);
  }, [selectedClasses]);

  // PDF data preparation
  let headerPdf = [
    "Class_Stream_Sec",
    "Student_Name",
    "F.Name",
    "Mob. No.",
    "First_Invoice_Number",
    "Total_Amount",
    "Total_Paid",
    "Discount",
    "Balance",
  ];

  let exportArrayPdf = state.tableData?.map((item) => {
    return {
      Class_Stream_Sec:
        FormatFullName(item?.className, item?.stream, item?.section) || "--",
      Student_Name: item.studentName || "",
      "F.Name": item?.fatherName || "",
      "Mob. No.": item?.studentDetail?.mobileNumber || "",
      First_Invoice_Number: item.firstInvoiceNumber || "--",
      Total_Amount: item.totalAmount || "",
      Total_Paid: item.paidAmount || "",
      Discount: item.discount || "",
      Balance: item.balance || "",
      CreatedBy: item.createdBy || "",
    };
  });

  return (
    <>
      <Helmet>
        <title>Books | Sale Book</title>
      </Helmet>
      <CustomLoader show={getSoldBookLoading || getSoldBookFetching} />
      {/* Filteres Modal */}
      <CommonFilterDialog
        handleSaveAndView={() => {
          getSoldBookRefetch();
        }}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Filter"
        minWidth="450px"
      >
        <DialogContent>
          <Stack>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkboxes.one}
                  onClick={() => {
                    setCheckboxes((prev) => ({ ...prev, one: !prev.one }));
                  }}
                />
              }
              label="Class info"
            />
            {checkboxes.one && (
              <Stack
                direction="row"
                alignItems="center"
                spacing={2}
                marginRight={2}
              >
                <ByClassFilter
                  prevClassList={selectedClasses}
                  setSelectedClasses={setSelectedClasses}
                  // onClassListChange={handleClassListChange}
                />
              </Stack>
            )}
          </Stack>
        </DialogContent>
      </CommonFilterDialog>

      {/* add new book dialog */}
      <SaleBookDialog
        open={dialogs?.add}
        onClose={() => {
          setDialogs((prev) => ({ ...prev, add: false }));
        }}
        refetch={getSoldBookRefetch}
        classData={state.classData}
      />

      {/* Universal Export Dialog - PDF */}
      <UniversalExportDialog
        open={state.checkExportOptionsPdf}
        onClose={() =>
          setState((prev) => ({ ...prev, checkExportOptionsPdf: false }))
        }
        exportType="pdf"
        pdfHeaders={headerPdf}
        pdfData={exportArrayPdf}
        fileName="Sale_Book"
        showSelectAll={true}
        showOrientation={true}
        showSchoolHeader={true}
      />

      {/* payment summary dialog */}
      <SaleBookPaymentDetail
        open={dialogs?.tPaid}
        onClose={() => {
          setDialogs((prev) => ({ ...prev, tPaid: false }));
        }}
        refetch={getSoldBookRefetch}
      />

      {/* Universal Export Dialog - Excel */}
      <UniversalExportDialog
        open={dialogs.export}
        onClose={() =>
          setDialogs((prev) => ({
            ...prev,
            export: false,
          }))
        }
        exportType="excel"
        excelHeaders={headerExcel}
        excelData={exportExcelArray}
        fileName="Book_Sale"
        showSelectAll={true}
        showOrientation={false}
        showSchoolHeader={true}
      />

      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <FilterButton
          count={
            Object.values(checkboxes).filter((item) => item === true).length
          }
          handleClick={() => setModalOpen(true)}
        />

        <Stack direction="row" gap={2} ml={isMobile && 2} alignItems="center">
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              mb: 0.5,
            }}
          >
            Total Student :{" "}
            <span style={{ fontSize: "18px" }}>{tableData?.length || 0}</span>
          </Typography>
          <Button
            variant="outlined"
            color="secondary"
            sx={{ fontSize: isMobile ? "8px" : "1.2rem" }}
            onClick={() => {
              setDialogs((prev) => ({ ...prev, add: true }));
            }}
          >
            + Sale Book
          </Button>
          <Box sx={{ mt: "-10px" }}>
            <ExportButtonGroup
              showPdf={true}
              handleClickPdf={() => {
                setState((prev) => ({
                  ...prev,
                  checkExportOptionsPdf: true,
                }));
              }}
              handleClickExcel={() =>
                setDialogs((prev) => ({ ...prev, export: true }))
              }
            />
          </Box>
        </Stack>
      </Stack>
      <Stack mt={3}>
        {/* <STable columns={columns} data={tableData || []} /> */}
        <CommonTable1 columns={columns} data={tableData} maxHeight="67vh" />
      </Stack>
    </>
  );
};

export default SaleBook;
